import { checkParams, zeroUnit, soFarDate, timePeriod } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	if (this.isMotion || this.isNewMotion || this.isResurvey) {
		return false
	}
	if (!this.isPAIC) {
		if (this.isAccidentInsurance || this.isHealthInsurance) {
			return false
		}
	}

	let arr = []

	let list = [{}]
	if (injured.livingInfoList && injured.livingInfoList.length) {
		list = injured.livingInfoList
	}
	for (const item of list) {
		const row = [
			{
				label: '居住地址',
				value: item.homeAddress && item.homeAddress + item.detailAddress,
			},
			{
				label: '居住起止日期',
				value: timePeriod(item.beginDate, item.endDate),
			},
			{
				label: '住房性质',
				value: setting.houseNatureMap[item.houseNature],
			},
		]
		if (item.houseNature === '01') {
			row.push({
				label: '是否有居住证/暂住证',
				value: setting.yesNoMap[item.residencePermit],
			})
		}
		row.push({
			label: '备注（非必填）',
			value: item.remark,
		})

		arr.push(row)
	}

	const obj = {
		title: '伤者至少超过一年的完整居住经历',
		children: arr,
	}

	return obj
}
